import React, { Component } from 'react';
import { Grid, Paper, Button, Select, MenuItem } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import { CircularProgress, Typography, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { Link } from 'react-router-dom';

import styles from '../App.css';
import componentStyles from './ViewCustomerCase.css.js';
import JsonForm from '../../components/JsonForm/JsonForm';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@inject('languageStore')
@observer
export default class ViewCustomerCase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      templates: [],
      selectedTemplate: null,
    };
  }

  fetchCase() {
    let id = this.props.match.params.id;
    this.props.customerCaseStore.fetchOneCustomerCase(id, this.props.languageStore.language); // fetch Customer Case by id
  }

  componentDidMount() {
    this.fetchCase();

    this.props.customerCaseStore.getTemplates()
      .then(templates => {
        this.setState({templates, selectedTemplate: templates.length > 0 ? templates[0]._id : null});
      });
  }

  changeTemplate(event) {
    this.setState({selectedTemplate: event.target.value});
  }

  renderData() {
    if (this.props.customerCaseStore.oneCustomerCaseState !== 'done') {
      return <CircularProgress />; // wait until the fetch is done and the store is updated
    } else {
      let customerCaseData = this.props.customerCaseStore.oneCustomerCase;
      let templateRenderList = this.props.customerCaseStore.templateRenderList;

      return (
          <Grid container spacing={40}>
            <Dialog open={this.props.customerCaseStore.removeDialogOpen}>
              <div style={componentStyles.removeDialogPaper}>
                <div style={componentStyles.removeDialogText}>
                  <b><Translation>dialog.confirmation</Translation></b>
                </div>
                <Grid container xs={12}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={componentStyles.marginButtonContainerLeft}
                  >
                    <Button
                      onClick={() =>
                        this.props.customerCaseStore.toggleRemoveDialogOpen()
                      }
                      variant={'contained'}
                      color={'primary'}
                      style={componentStyles.marginButtonLeft}
                    >
                      <Translation>cancel</Translation>
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={componentStyles.marginButtonContainerRight}
                  >
                    <Button
                      onClick={() => {
                          this.props.customerCaseStore.removeCustomerCase(
                            customerCaseData._id
                          );

                          this.props.customerCaseStore.toggleRemoveDialogOpen();
                        }
                      }
                      component={Link}
                      to={'/cases'}
                      variant={'contained'}
                      color={'secondary'}
                      style={componentStyles.marginButtonRight}
                    >
                      <Translation>delete</Translation>
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Dialog>
            <Grid item xs={12}>
              <JsonForm
                mode="view"
                data={this.props.customerCaseStore.oneCustomerCase}
                language={this.props.languageStore.language}
                labelLanguage={this.props.languageStore.language}
                schema={this.props.customerCaseStore.caseSchema}
              />
            </Grid>
            <Grid
              container
            >
              <Grid
                item
                xs={12}
                sm={6}
                style={componentStyles.marginButtonContainerLeft}
              >
              {/* Muokkaus nappi */}

              {(() => {
                if (!templateRenderList['button.edit']) {
                  return (
                    <Button
                      component={Link}
                      to={`/case/create/${
                        customerCaseData._id
                      }`}
                      variant={'contained'}
                      color={'primary'}
                      style={componentStyles.marginButtonLeft}
                    >
                      <Translation>edit</Translation>
                    </Button>
                  );
                }
              })()}

              {/* Case poisto nappi */}

              {(() => {
                if (!templateRenderList['button.remove']) {
                  return (
                      <Button
                        onClick={() =>
                          this.props.customerCaseStore.toggleRemoveDialogOpen()
                        }
                        variant={'contained'}
                        color={'secondary'}
                        style={{...componentStyles.marginButtonLeft, ...styles.marginLeft}}
                      >
                        <Translation>delete</Translation>
                      </Button>
                  );
                }
              })()}

              </Grid>

              {/* Pdf tilaus nappi */}

              {(() => {
                if (!templateRenderList['button.pdf']) {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{...componentStyles.flexGrid, textAlign: 'right'}}
                    >
                      <Select
                        value={this.state.selectedTemplate}
                        onChange={this.changeTemplate.bind(this)}
                        style={componentStyles.flex}>
                        {(() => {
                          return (
                            this.state.templates.map(template => {
                              return (
                                <MenuItem value={template._id}>{template.name}</MenuItem>
                              );
                            })
                          )
                        })()}
                      </Select>
                      <Button
                        onClick={() =>
                          this.props.customerCaseStore.fetchPdf(
                            customerCaseData._id,
                            this.state.selectedTemplate,
                            this.props.languageStore.language
                          )
                        }
                        variant={'contained'}
                        color={'default'}
                        style={componentStyles.marginButtonRight}
                      >
                        <Translation>action.export_pdf</Translation>
                      </Button>
                    </Grid>
                  );
                }
              })()}
            </Grid>
          </Grid>
      );
    }
  }
  render() {
    return (
      <Grid item xs={12}>
        <Paper style={styles.paper}>{this.renderData()}</Paper>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/ViewCustomerCase.jsx